<template>
  <div style="line-height:auto">
    <a :href="$host + '/bot-click' + cclink" target="_blank">
      <img :src="$assetUrl('singlepix.gif')" style="border:0;outline:none;display:block;" />
    </a>
  </div>
</template>
<script>

export default {
  props: {
    cclink: String
  },
}
</script>
